import { useState, useEffect } from 'react'
import { api } from '../../../services/api'
import { useRateLimit } from '../../../hooks/useRateLimit'
import { RateLimitIndicator } from '../../../components/RateLimitIndicator'
import { AddButton, TableContainer, Table, Tr, Td, Th } from './styles'
import {
  Container,
  Card,
  Select,
  InputDiv,
  ActionButtonsRow,
  PageContainer,
  PageHeader,
  InfoCard,
  Badge,
  BackButton,
  Result,
  MathDiv,
  CopyHTMLButton,
} from '../../../styles/global'
import { FaPlusCircle } from 'react-icons/fa'
import { FaMinusCircle } from 'react-icons/fa'
import { FiArrowLeft, FiInfo } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { BlockMath } from 'react-katex'
import 'katex/dist/katex.min.css'
import { copyResultsToClipboard } from '../../../utils/copyResultsToClipboard'

export function ElectricalConduit() {
  const { canCalculate, updateFromHeaders, handleRateLimitError, fetchRateLimitStatus } = useRateLimit()

  const [quantity, setQuantity] = useState('')
  const [wires, setWires] = useState([0])
  const [customName, setCustomName] = useState('')
  const [customDiameter, setCustomDiameter] = useState(0)
  const [selectedWire, setSelectedWire] = useState([])
  const [usedWires, setUsedWires] = useState([])
  const [result, setResult] = useState('')
  const [isFormValid, setIsFormValid] = useState(false)
  const [isAddButtonActive, setIsAddButtonActive] = useState(false)

  useEffect(() => {
    async function fetchData() {
      const response = await api.get('/electrical/conduit/data')
      setWires([...response.data.wires, 'Personalizado'])
    }

    fetchData()
  }, [])

  const customField = (() => {
    if (selectedWire == 'Personalizado')
      return (
        <>
          <InputDiv>
            <span>Descrição</span>
            <input type="text" value={customName} onChange={(event) => setCustomName(event.target.value)} />
          </InputDiv>
          <InputDiv>
            <span>Diâmetro externo (mm)</span>
            <input
              type="text"
              value={customDiameter}
              onChange={(event) => setCustomDiameter(Number(event.target.value))}
            />
          </InputDiv>
        </>
      )
  })()

  useEffect(() => {
    if (usedWires.length < 1) {
      setIsFormValid(false)
    } else setIsFormValid(true)
  }, [usedWires, isFormValid])
  useEffect(() => {
    if (quantity !== '') {
      setIsAddButtonActive(false)
    } else setIsAddButtonActive(true)
  }, [quantity])

  useEffect(() => {
    setSelectedWire(wires[0])
  }, [wires])

  const handleWireChange = (event) => {
    const selectedType = event.target.value
    setSelectedWire(selectedType)
  }

  async function handleCalculate(event) {
    event.preventDefault()

    try {
      const data = {
        usedWires,
      }

      const response = await api.post('/electrical/conduit', data)
      setResult(response.data)

      if (response.rateLimit) {
        updateFromHeaders({
          'x-ratelimit-limit': response.rateLimit.limit.toString(),
          'x-ratelimit-remaining': response.rateLimit.remaining.toString(),
          'x-ratelimit-reset': response.rateLimit.reset,
        })
      }

      await fetchRateLimitStatus()
      toast.success('Cálculo atualizado')
    } catch (error) {
      console.error('Erro ao calcular:', error)

      if (handleRateLimitError(error)) {
        toast.error(error.response?.data?.message || 'Você atingiu o limite de cálculos diários.')
        return
      }

      toast.error('Erro ao realizar o cálculo. Tente novamente.')
    }
  }

  function handleFileSave() {
    const stateData = {
      quantity,
      wires,
      customName,
      customDiameter,
      selectedWire,
      usedWires,
      result,
    }
    const jsonString = JSON.stringify(stateData, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'state.json'
    link.click()
    URL.revokeObjectURL(url)
  }

  function handleFileUpload(event) {
    const file = event.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const jsonData = JSON.parse(e.target.result)
        setQuantity(jsonData.quantity)
        setWires(jsonData.wires)
        setCustomName(jsonData.customName)
        setCustomDiameter(jsonData.customDiameter)
        setSelectedWire(jsonData.selectedWire)
        setUsedWires(jsonData.usedWires)
        setResult(jsonData.result)
      } catch (error) {
        console.error('Erro ao ler o arquivo JSON:', error)
      }
    }
    reader.readAsText(file)
  }

  function handleAddWire(event) {
    event.preventDefault()

    if (selectedWire != 'Personalizado') setUsedWires([...usedWires, { quantity, type: selectedWire }])
    else setUsedWires([...usedWires, { quantity, type: selectedWire, name: customName, diameter: customDiameter }])
    toast.success('Condutor adicionado')
  }

  const removeWire = (event, indexToRemove) => {
    event.preventDefault()
    setUsedWires((prevWires) => prevWires.filter((_, index) => index !== indexToRemove))
  }

  function handleCopyResults() {
    copyResultsToClipboard({
      result,
    })
  }

  function renderCalculationSteps(steps) {
    if (!steps) return null

    return (
      <>
        <h3>Área de cada cabo</h3>
        <MathDiv>
          {steps.wires.map((wire, index) => (
            <BlockMath
              key={index}
              math={`A_{${wire.name}}= \\dfrac{\\pi \\cdot d^2}{4} \\cdot n = \\dfrac{3,1416 \\cdot ${wire.diameter}^2}{4} \\cdot ${wire.quantity} = ${wire.totalArea} \\, \\text{mm}^2`}
            />
          ))}
        </MathDiv>

        <h3>Área total dos cabos</h3>
        <MathDiv>
          <BlockMath math={`A_{cabos}= \\sum A_{i} = ${steps.wiresArea} \\, \\text{mm}^2`} />
        </MathDiv>

        <h3>Taxa de ocupação</h3>
        <MathDiv>
          <p>
            {steps.wiresQuantity} condutor(es) → {steps.conduitUsageReason}
          </p>
          <BlockMath math={`\\text{Taxa} = ${steps.conduitUsagePercentage}\\%`} />
        </MathDiv>

        <h3>Área mínima do eletroduto</h3>
        <MathDiv>
          <BlockMath
            math={`A_{min}= \\dfrac{A_{cabos}}{\\text{Taxa}} = \\dfrac{${steps.wiresArea}}{${steps.conduitUsage}} = ${steps.neededConduitArea} \\, \\text{mm}^2`}
          />
        </MathDiv>

        <h3>Diâmetro interno mínimo</h3>
        <MathDiv>
          <BlockMath
            math={`D_{min}= \\sqrt{\\dfrac{4 \\cdot A_{min}}{\\pi}} = \\sqrt{\\dfrac{4 \\cdot ${steps.neededConduitArea}}{3,1416}} = ${steps.requiredInternalDiameter} \\, \\text{mm}`}
          />
        </MathDiv>

        <h3>Seleção do eletroduto</h3>
        <MathDiv>
          <p>{steps.conduitSelectionRule}</p>
          {steps.selectedConduit ? (
            <>
              <p>
                Eletroduto selecionado: {steps.selectedConduit.name} (diâmetro interno:{' '}
                {steps.selectedConduit.internalDiameter} mm)
              </p>
              <BlockMath
                math={`A_{eletroduto}= \\dfrac{\\pi \\cdot D^2}{4} = \\dfrac{3,1416 \\cdot ${steps.selectedConduit.internalDiameter}^2}{4} = ${steps.conduitArea} \\, \\text{mm}^2`}
              />
              <BlockMath
                math={`\\boxed{\\text{Ocupação} = \\dfrac{A_{cabos}}{A_{eletroduto}} \\cdot 100 = \\dfrac{${steps.wiresArea}}{${steps.conduitArea}} \\cdot 100 = ${steps.areaRatio}\\%}`}
              />
            </>
          ) : (
            <p>Nenhum eletroduto cadastrado atende ao diâmetro interno mínimo calculado.</p>
          )}
        </MathDiv>
      </>
    )
  }

  const headerGradient = 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'

  return (
    <PageContainer>
      <PageHeader $gradient={headerGradient}>
        <div className="header-content">
          <BackButton to="/eletrica">
            <FiArrowLeft /> Voltar para Elétrica
          </BackButton>
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <a href="/eletrica">Elétrica</a>
            <span>/</span>
            <span>Eletroduto</span>
          </div>
          <h1>Dimensionamento de eletrodutos</h1>
          <p className="subtitle">
            Verifique ocupação e selecione o eletroduto adequado para o conjunto de condutores conforme NBR 5410.
          </p>
          <div className="badges">
            <Badge>NBR 5410</Badge>
            <Badge>Ocupação máxima</Badge>
            <Badge>Condutores</Badge>
          </div>
        </div>
      </PageHeader>

      <InfoCard
        $background="linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)"
        $border="2px solid #fb923c"
        $primaryColor="#c2410c"
      >
        <div className="info-content">
          <div className="icon">
            <FiInfo />
          </div>
          <div className="text">
            <h3>Sobre esta calculadora</h3>
            <p>
              Cadastre os condutores por quantidade e bitola, com opção de diâmetro personalizado, para calcular a área
              ocupada.
            </p>
            <p>Compare com o limite de ocupação e obtenha o eletroduto recomendado com base na norma vigente.</p>
            <div className="norms">
              <span>NBR 5410</span>
              <span>Taxas de ocupação</span>
            </div>
          </div>
        </div>
      </InfoCard>

      <Container>
        <Card>
          <RateLimitIndicator />

          <h2>Eletroduto</h2>
          <h3>Inserção de cabos</h3>
          <form onSubmit={handleCalculate}>
            <InputDiv>
              <span>Tipo de cabo</span>
              <div>
                <Select style={{ marginLeft: '0' }} id="wireSelect" value={selectedWire} onChange={handleWireChange}>
                  {wires.map((wire, index) => (
                    <option key={index} value={wire}>
                      {wire}
                    </option>
                  ))}
                </Select>
              </div>
            </InputDiv>
            {customField}
            <InputDiv>
              <span>Quantidade</span>
              <div>
                <input
                  type="number"
                  value={quantity || ''}
                  onChange={(event) => setQuantity(Number(event.target.value))}
                />
                <AddButton type="submit" disabled={isAddButtonActive} onClick={handleAddWire}>
                  <FaPlusCircle />
                </AddButton>
              </div>
            </InputDiv>
            <h3>Cabos inseridos</h3>
            {usedWires.length > 0 ? (
              <TableContainer>
                <Table style={{ marginTop: '20px' }}>
                  <thead>
                    <Tr>
                      <Th>Quantidade</Th>
                      <Th>Seleção</Th>
                      <Th>Nome personalizado</Th>
                      <Th>Diâmetro externo (mm) personalizado</Th>
                      <Th>Remover</Th>
                    </Tr>
                  </thead>
                  <tbody>
                    {usedWires.map((w, index) => (
                      <Tr key={index}>
                        <Td>{w.quantity}</Td>
                        <Td>{w.type}</Td>
                        <Td>{w.name == null ? '' : w.name}</Td>
                        <Td>{w.name == null ? '' : w.diameter}</Td>
                        <Td style={{ textAlign: 'center' }}>
                          <button onClick={(event) => removeWire(event, index)}>
                            <FaMinusCircle />
                          </button>
                        </Td>
                      </Tr>
                    ))}
                  </tbody>
                </Table>
              </TableContainer>
            ) : (
              'Nenhum cabo inserido até o momento.'
            )}
            <ActionButtonsRow>
              <button type="button" onClick={handleFileSave}>
                Salvar
              </button>
              <button type="button" onClick={() => document.getElementById('file-input').click()}>
                Carregar
              </button>
              <button type="submit" disabled={!isFormValid || !canCalculate}>
                {!canCalculate ? 'Limite atingido' : 'Calcular'}
              </button>
            </ActionButtonsRow>
            <input type="file" id="file-input" onChange={handleFileUpload} style={{ display: 'none' }} />
          </form>
        </Card>
        {result !== '' && (
          <>
            <Result>
              <h2>Resultado</h2>
              <p>Área dos cabos: {result.wiresArea} mm²</p>
              <p>
                Eletroduto necessário:{' '}
                {result.conduit ? result.conduit.name : 'Nenhum eletroduto suporta essa quantidade de cabos'}
              </p>
              <p>Área do conduíte: {result.conduit ? result.conduitArea + 'mm ²' : 'Não calculado'}</p>
              <p>Uso do conduíte: {result.conduit ? result.areaRatio + '%' : 'Não calculado'}</p>
            </Result>
            {result.calculationSteps && (
              <Result className="results-section">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <h2>Cálculos</h2>
                  <CopyHTMLButton type="button" onClick={handleCopyResults}>
                    📋 Copiar Cálculos
                  </CopyHTMLButton>
                </div>
                {renderCalculationSteps(result.calculationSteps)}
              </Result>
            )}
          </>
        )}
      </Container>
    </PageContainer>
  )
}
